// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falRectangleWide: CreateIconOptions = {
  "displayName": "FALRectangleWide",
  "viewBox": "0, 0, 640, 512",
  "d": "M576 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l512 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z"
};
